export default __webpack_public_path__ + "static/media/artim-logo.8433953a.png";